import React, { createContext, useContext, useState, useMemo, type ReactNode } from 'react';

type RelatedWorkMutationLoadingContextType = {
	isAddingRelatedWork: boolean;
	setIsAddingRelatedWork: (isAddingRelatedWork: boolean) => void;
};

const RelatedWorkMutationLoadingContext =
	createContext<RelatedWorkMutationLoadingContextType | null>(null);

type Props = {
	children: ReactNode;
};

export const RelatedWorkMutationLoadingProvider = ({ children }: Props) => {
	const [isAddingRelatedWork, setIsAddingRelatedWork] = useState(false);

	const contextValue = useMemo(
		() => ({ isAddingRelatedWork, setIsAddingRelatedWork }),
		[isAddingRelatedWork, setIsAddingRelatedWork],
	);

	return (
		<RelatedWorkMutationLoadingContext.Provider value={contextValue}>
			{children}
		</RelatedWorkMutationLoadingContext.Provider>
	);
};

export const useRelatedWorkMutationLoading = () => {
	const context = useContext(RelatedWorkMutationLoadingContext);

	if (context === null) {
		return {
			isAddingRelatedWork: false,
			setIsAddingRelatedWork: () => {
				// do nothing
			},
		};
	}

	return context;
};
